import React from 'react';

import {DropZone} from '@pb/kit-component-dropzone';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import Loading from '@pb/kit-component-loading';

import {MAX_RECORDS} from '../constants';

import {Header} from './header';

import {noListPage} from './no-list-page.module.styl';

type Props = {
    isLoading: boolean,
    onLoadFile: (acceptedFiles: File[]) => void,
};

export const NoListPage = ({onLoadFile, isLoading}: Props) => {
    return (
        <>
            <Header disabled={true}/>
            <div className={noListPage}>
                {isLoading ? <Loading fast={true}/> : (
                    <DropZone
                        multiple={false}
                        onDrop={onLoadFile}
                        mix="dropzone"
                        accept="text/csv,application/vnd.ms-excel">
                        <div style={{width: 900}}>
                            <Group direction="v" gap="xxs">
                                <Icon className="dropzone__service-icon" type={Icons.UPLOAD}/>
                                <span>Drag & drop a file to upload or <a>browse</a></span>
                                <span>Max. users count: {MAX_RECORDS} records. Accepted formats: CSV</span>
                                <span>Required columns: <b>Email</b> or <b>ID</b></span>
                            </Group>
                        </div>
                    </DropZone>
                )}
            </div>
        </>
    );
};
